/**
 * A shallow copy with every undefined-valued key removed.
 *
 * Firestore rejects `undefined` anywhere in a write, including nested inside a
 * map or an array element — the updaters' own `stripUndefined` only sweeps the
 * patch's top-level keys, so an object built with `{ url: undefined }` reached
 * `updateDoc` intact and threw.
 *
 * Dropping the key is how you clear something INSIDE a value that is written
 * whole: absent from the object is absent from the document. Clearing a
 * top-level FIELD is the other rule and needs an explicit `null`, because
 * `updateDoc` merges and a missing field is simply left alone.
 */
export function withoutUndefined<T extends object>(obj: T): T {
  return Object.fromEntries(
    Object.entries(obj).filter(([, value]) => value !== undefined),
  ) as T;
}
